import { useDeferredValue, useEffect, useState } from 'react'
import classes from './VideoQuiz.module.scss'
import { Slices } from '../Slices';
import { SliceVideo } from '../Slices/SliceVideo';
import { TimeBar } from '../TimeBar';
import ButtonSend from '../ButtonSend';
import { useDispatch } from 'react-redux';
import { finishGame, goToQuestion, setShowBankControl } from '@educaplay/store/slices/gameSlice';
import { GAMEMODE, QUESTION_TYPE } from '../../utils/constants';
import {  useMediaQuery } from '@educaplay/core';
import { getQuestion, getSequence } from '../../utils/functions';
import useVideo from '../../hooks/useVideo';
import useVideoQuizConfig from '../../hooks/useVideoQuizConfig';
import useSlice from '../../hooks/useSlice';
import { VideoControl } from '../VideoControl';
import { SCREENS } from '@educaplay/store/constants';
import { useSelector } from 'react-redux';
import { ConfirmationDialog } from '../ConfirmationDialog';
import BackButton from '../BackButton';

function VideoQuiz({ onAnswer, currentQuestion, questions }) {

    const { sequences, progress, changePlaying, playing, play } = useVideo();
    const deferredPlaying = useDeferredValue(playing, { timeoutMs: 500 });
    const { showSlice, openConfirmationDialog, setOpenConfirmationDialog, setShowSlice, currentQuestionTimeAppear, showSendButton, setShowSendButton } = useSlice();
    const { gameMode } = useVideoQuizConfig();
    const nextQuestion = questions.findIndex(q => q.id === currentQuestion.id) + 1 < questions.length ? questions[currentQuestion.id + 1] : null;
    const nextQuestionTimeAppear = nextQuestion?.timeAppearWithDuration ?? nextQuestion?.timeAppear;
    const currentSequence = getSequence(sequences, progress);
    const ChangeQuestionIndex = questions.findIndex(question => question.id === getQuestion(questions, progress).id);
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const totalDuration = currentQuestion.totalDuration;
    const [visitedQuestions, setVisitedQuestions] = useState([]);
    const view = useSelector(state => state.game.view);
    const dispatch = useDispatch();

    useEffect(() => {
        if (progress !== totalDuration || view !== SCREENS.GAME) return;
        const hasAnsweredAllQuestions = questions.every(question => question.answer?.answer != null);
        if (hasAnsweredAllQuestions) {
            const finishParams = questions.every((question) => question.questionType === QUESTION_TYPE.Info) ? { points: 100 } : null;
            dispatch(finishGame(finishParams))
            return;
        } else {
            if (gameMode === GAMEMODE.SEQUENTIAL) return;
            setShowSendButton(true);
        }
    }, [progress, totalDuration, questions, dispatch, gameMode, view, setShowSendButton])

    useEffect(() => {
        if (showSendButton || gameMode === GAMEMODE.SEQUENTIAL) return;
        if (progress !== currentQuestionTimeAppear) return;
        if (visitedQuestions.includes(currentQuestion.id)) return;
        setVisitedQuestions([...visitedQuestions, currentQuestion.id]);
        if (visitedQuestions.length + 1 === questions.length) {
            setShowSendButton(true);
        }
    }, [currentQuestion.id, currentQuestion.timeAppear, currentQuestion.timeAppearWithDuration, setShowSendButton,
        progress, visitedQuestions, questions.length, showSendButton, gameMode, currentQuestionTimeAppear])

    useEffect(() => {
        dispatch(goToQuestion(ChangeQuestionIndex));
    }, [ChangeQuestionIndex, dispatch])

    const onAnswerHandler = (userAnswer) => {
        onAnswer(userAnswer, { showFeedback: true });
    }

    const playpausehandler = (options = {}) => {
        if (showSlice && currentQuestionTimeAppear === progress) {
            const { acceptDialog = false } = options;
            if (gameMode === GAMEMODE.SEQUENTIAL && !acceptDialog && currentQuestion.questionType !== QUESTION_TYPE.Info) {
                setOpenConfirmationDialog(true);
                return;
            }
            if (nextQuestion) dispatch(goToQuestion(questions.findIndex(q => q.id === nextQuestion.id)));
            if (nextQuestionTimeAppear === currentQuestionTimeAppear) return;
            setShowSlice(false);
            dispatch(setShowBankControl(false));
            if (progress >= totalDuration && gameMode === GAMEMODE.SEQUENTIAL && view === SCREENS.GAME) {
                const finishParams = questions.every((question) => question.questionType === QUESTION_TYPE.Info) ? { points: 100 } : null;
                dispatch(finishGame(finishParams))
                return;
            }
            if (progress < totalDuration) play();
            return;
        }
        if (progress === totalDuration) return;
        changePlaying();
    }

    const closeDialog = (e) => {
        e?.stopPropagation();
        setOpenConfirmationDialog(false);
    }

    return (
        <>
            <ConfirmationDialog open={openConfirmationDialog} onClose={closeDialog} playpausehandler={playpausehandler} />
    
            <div className={classes.game}>
                <VideoControl show={deferredPlaying} onClick={playpausehandler} />
                <div className={classes.video}
                    onClick={playpausehandler}>
                    <SliceVideo
                        currentSequence={currentSequence}
                    />
                    <Slices
                        key={currentQuestion.id}
                        questions={questions}
                        onAnswer={onAnswerHandler}
                        onPassQuestion={playpausehandler}
                    />
                </div>
                <div className={classes.timeBar}>
                    <TimeBar
                        questions={questions}
                        totalDuration={totalDuration}
                        interactive={gameMode === GAMEMODE.FREEDOM}
                        currentQuestion={currentQuestion}
                        nextQuestion={nextQuestion}
                        showSendButton={showSendButton}
                        onClick={playpausehandler}

                    />
                </div>
                <div className={classes.btnsendcontainer}>
                    <ButtonSend passFinalQuestion={showSendButton && view === SCREENS.GAME} />
                </div>
            </div>
            <BackButton show={isTouchDevice && gameMode === GAMEMODE.FREEDOM} />
        </>
    )
}

export default VideoQuiz
